// router/modules/index.js
const files = require.context(".", false, /\.js$/);
const modules = [];

//获取路由表
files.keys().forEach((key) => {
    if (key === "./index.js") return;
    const item = files(key).default;
    modules.push(...item);
});

export default modules;
